import { useAppDispatch } from "@/app/appStore";
import {
  setHighlightedTimelineEventId,
  setSelectedEvent,
} from "@/entities/annotation";
import { Cross1Icon } from "@radix-ui/react-icons";
import { Box, Flex, IconButton, ScrollArea, Text } from "@radix-ui/themes";
import { ReactNode } from "react";

export const EventDetailsWrapper: React.FC<{
  children: ReactNode;
}> = ({ children }) => {
  const dispatch = useAppDispatch();

  const handleCloseEventDetails = () => {
    dispatch(setSelectedEvent(null));
    dispatch(setHighlightedTimelineEventId(null));
  };

  return (
    <ScrollArea className="h-[calc(100%-24px)]">
      <Flex align="center">
        <IconButton
          variant="ghost"
          color="gray"
          mx="2"
          onClick={handleCloseEventDetails}
        >
          <Cross1Icon />
        </IconButton>
        <Text size="2" weight="bold" m="2" as="p">
          Event details
        </Text>
      </Flex>
      <Box px="2">{children}</Box>
    </ScrollArea>
  );
};
